<template >
    <div>
        <v-card 
            flat 
            class="py-2 px-4" 
            color="white"
        >
            <v-row class="d-flex">
                <v-col cols="11">
                    <div class="font-weight-bold">
                        {{ $t('map.searchRoute') }}
                    </div>
                </v-col>
                <v-col 
                    cols="1" 
                    class="d-flex justify-end"
                >
                    <v-btn 
                        @click="closeSearchBlock()" 
                        icon
                    >
                        <v-icon 
                            small 
                            color="black" 
                            class="mdi"
                        >
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <div class="search-block">
                <input
                    v-show="isSearchExist()"
                    type="search"
                    ref="search"
                    v-model="inputSearch"
                    :placeholder="searchPlaceholder()"
                >
                <button
                    v-if="inputSearch === ''"
                    class="btn-search"
                >
                    <em class="icon icon-search search-btn"/>
                </button>
                <button
                    v-else class="btn-search"
                    @click="resetSearch()"
                >
                    <em class="icon icon-close reset-btn"/>
                </button>
            </div>
            <div
                class="result-search-block"
                v-show="!!data.info"
            >
                {{ data.info }}
            </div>
            <v-card  
                flat
                tile class="d-flex justify-space-between pt-4"
            >
                <v-card
                    outlined
                    tile
                    v-for="(item, id) in getItems()"
                    :key="id"
                    :style="{border: 0}"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                v-bind="attrs"
                                v-on="on"
                                href="#"
                                :class="{ 'active': item.active }"
                                @click.prevent="setActive(item)"
                            >
                                <span class="icon-holder">
                                    <svg
                                        width="30"
                                        height="30"
                                    >
                                        <image
                                            v-if="item.active"
                                            :xlink:href="item.icon"
                                            :src="item.icon"
                                            width="30"
                                            height="30"
                                        />
                                        <image
                                            v-else
                                            :xlink:href="item.inactiveIcon"
                                            :src="item.inactiveIcon"
                                            width="30"
                                            height="30"
                                        />
                                    </svg>
                                </span>
                            </a>
                        </template>
                        <span>
                            {{ item.text }}
                        </span>
                    </v-tooltip>
                </v-card>
            </v-card>
        </v-card>
    </div>
</template>

<script>
    import { EventBus } from "@/event-bus";
    export default {
        name: "SearchRoute",
        data() {
            return {
                inputSearch: "",
            }
        },
        props:[
            "data"
        ],
        mounted() {
            if (typeof this.data.search === 'function')
                this.data.search(this.$refs.search);
                
            this.data.gui.itinerary.filter(el => !!el.active).forEach(el => {
            if (typeof this.data.travelMode === 'function')
                this.data.travelMode(el.id);
            });    
        },
        methods: {
            getItems() {
                return this.data.gui.itinerary.filter(el => el.id !== 'destination');
            },
            isSearchExist() {
                return this.data.gui.itinerary.filter(el => el.id === 'destination').length;
            },
            searchPlaceholder() {
                const item = this.data.gui.itinerary.filter(el => el.id === 'destination');
                return item.length && item[0].text ? item[0].text : '';
            },
            resetSearch() {
                this.inputSearch = '';
                this.$refs.search.value = '';
            },
            setActive(item) {
                if (!item.active) {
                    this.data.gui.itinerary.filter(el => el.active).forEach(el => el.active = false);
                    this.$set(item, 'active', true);
                    EventBus.$emit('map_SetActive', item);
                }
            },
            closeSearchBlock(){
                this.$emit('toggle-search-route');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/map/components/SearchRouteFooter.vue